import React from 'react';

import { FilterContainer } from './FilterStyles';
import Button from 'common/Button/Button';

const MobileFilter = ({ toggleFilter }) => (
	<FilterContainer>
		<Button
			btnTxt='EXPLORE VENUE'
			btnType='Flat'
			btnName='Primary'
			btnShadow
			handleClick={toggleFilter}
		/>
	</FilterContainer>
);

export default MobileFilter;
